/* eslint-disable array-callback-return */
import Dropzone from 'react-dropzone';
import { useEffect, useState, createRef } from 'react';
import { connect } from 'react-redux';
import noUser from '../../assets/img/no_user.jpg';
import { getUserImage } from '../../services/user';
import { getGalleryImage } from '../../services/gallery';

const MyDropZone = ({
  uploadUserImage,
  itemId,
  profile,
  setProfile,
  member,
  setPreviewScreen,
  previewScreen,
  setImageEditData,
  modalAction,
}) => {
  const [imageData, setImageData] = useState(noUser);
  const dropzoneRef = createRef();
  useEffect(() => {
    // console.log('item.', itemId, profile);
    setImageData(noUser);
    setProfile([]);
    (async () => {
      let resImg;
      if (itemId) {
        if (member === 'user') {
          resImg = await getUserImage(itemId);
        } else if (member === 'gallery') {
          resImg = await getGalleryImage(itemId);
        } else {
          resImg = await getGalleryImage(itemId);
        }

        if (
          resImg.status === 200 &&
          resImg.data &&
          Buffer.from(resImg.data, 'binary')?.length
        ) {
          let base64ImageString = Buffer.from(resImg.data, 'binary').toString(
            'base64'
          );

          setImageData('data:image/jpeg;base64,' + base64ImageString);
          setImageEditData &&
            setImageEditData('data:image/jpeg;base64,' + base64ImageString);
          setPreviewScreen((prevState) => ({
            ...prevState,
            image: 'data:image/jpeg;base64,' + base64ImageString,
          }));
        } else {
          setPreviewScreen((prevState) => ({
            ...prevState,
            image: noUser,
          }));
        }
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [itemId]);
  return (
    <>
      <Dropzone
        accept='image/png,image/jpg,image/jpeg'
        onDrop={(acceptedFiles) => {
          const imageDataOnDrop = acceptedFiles.map((file) =>
            Object.assign(file, {
              preview: URL.createObjectURL(file),
            })
          );
          setProfile(imageDataOnDrop);
          imageDataOnDrop.map((file) => {
            setPreviewScreen((prevState) => ({
              ...prevState,
              image: file.preview,
            }));
          });
          uploadUserImage(acceptedFiles);
        }}
        ref={dropzoneRef}
        multiple={false}>
        {({ getRootProps, getInputProps }) => (
          <section>
            <div {...getRootProps()}>
              <input {...getInputProps()} />
              {member !== 'contact' ? (
                profile.length > 0 ? (
                  profile.map((file, index) => {
                    return (
                      <img
                        src={
                          previewScreen.image
                            ? previewScreen.image
                            : file.preview
                        }
                        alt='img'
                        key={index}
                      />
                    );
                  })
                ) : (
                  <img
                    src={previewScreen.image ? previewScreen.image : imageData}
                    alt='img'
                    onError={(e) => {
                      e.target.src = noUser;
                    }}
                  />
                )
              ) : (
                <button type='button' className='btn btn-primary mb-3'>
                  Select From System
                </button>
              )}
            </div>
          </section>
        )}
      </Dropzone>
      {member === 'user' && (
        <span
          onClick={() => dropzoneRef.current.open()}
          style={{ cursor: 'pointer' }}>
          {modalAction === 'add' ? 'Upload Avatar' : 'Edit Avatar'}
        </span>
      )}
    </>
  );
};

const mapStateToProps = ({ activeTabReducer: { modalAction } }) => ({
  modalAction: modalAction,
});

export default connect(mapStateToProps)(MyDropZone);
